export enum ExchangeModal {
  EXCHANGE_SHOP_FILTERS = 'EXCHANGE_SHOP_FILTERS',
}
